export default __webpack_public_path__ + "static/media/Limfjorden.654b30cd.xlsx";